export const GET_ITEM_CART_LOADING = "getitemcart/loading"
export const GET_ITEM_CART_SUCCESS = "getitemcart/success"
export const GET_ITEM_CART_ERROR = "getitemcart/error"


export const ADD_TO_CART_LOADING = "addtocart/loading";
export const ADD_TO_CART_SUCCESS = "addtocart/success";
export const ADD_TO_CART_ERROR = "addtocart/error";

export const REMOVE_FROM_CART_LOADING = "removefromcart/loading";
export const REMOVE_FROM_CART_SUCCESS = "removefromcart/success";
export const REMOVE_FROM_CART_ERROR = "removefromcart/error";

export const UPDATE_CART_LOADING = "updatecart/loading";
export const UPDATE_CART_SUCCESS = "updatecart/success";
export const UPDATE_CART_ERROR = "updatecart/error";

export const GET_PRODUCT_DETAILS_LOADING = "getproductdetails/loading";
export const GET_PRODUCT_DETAILS_SUCCESS = "getproductdetails/success";
export const GET_PRODUCT_DETAILS_ERROR = "getproductdetails/error";


export const REMOVE_ALL_FROM_CART_LOADING = "removeallfromcart/loading";
export const REMOVE_ALL_FROM_CART_SUCCESS = "removeallfromcart/success";
export const REMOVE_ALL_FROM_CART_ERROR = "removeallfromcart/error";